import React from 'react';
import PropTypes from 'prop-types';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { directDebitPropTypes } from '../../../states/managePayments/propTypes';
import IFTDetails from '../PaymentDetails/IFTDetails';
import PrintHelper from 'print-helper-lib';

const ViewIFTPayment = ({ mandate = {}, header, brandId }) => (
	<div>
		<SectionHeading>{header}</SectionHeading>
		<PrintHelper className="web-ui-components" brandId={brandId} showPrintTopIcon showPrintBottomIcon={false} />
		<IFTDetails mandate={mandate} />
	</div>
);

ViewIFTPayment.propTypes = {
	mandate: PropTypes.shape(directDebitPropTypes),
	content: PropTypes.shape({
		fromLabel: PropTypes.string.isRequired,
		toLabel: PropTypes.string.isRequired,
		lastAmountLabel: PropTypes.string.isRequired,
		lastPaidLabel: PropTypes.string.isRequired,
		lastPaymentReferenceLabel: PropTypes.string.isRequired,
	}),
	header: PropTypes.string.isRequired,
	brandId: PropTypes.string.isRequired,
};

export default ViewIFTPayment;
